import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ComponenteActualizarExistencias from '../ActualizarExistencias';
import formatCurrency from '../../utils/formatCurrency';
import ConteoCheck from '../productos/ConteoCheck';
import { getStatusClasses, getPriorityClasses } from '../../utils/LabelColors';
import { Tooltip } from 'react-tooltip';
import { FaCopy } from 'react-icons/fa';
import copyToClipboard from '../clipboard';
import Cookies from 'js-cookie';
import { useMediaQuery } from 'react-responsive';
import TablaVariantes from '../productos/TablaVariantes';

const ModalProductoPadre = ({ productoPadre, onClose, token }) => {
  // Detectar si estamos en mobile (maxWidth: 767) o desktop
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [productosHijos, setProductosHijos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null); // Para el acordeón en mobile

  useEffect(() => {
    const fetchProductosHijos = async () => {
      try {
        const response = await axios.get(`/api/productos/hijos/${productoPadre.id_producto}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProductosHijos(response.data);
      } catch (error) {
        console.error('Error al obtener los productos hijos:', error);
        const errorMessage =
          error.response?.status === 403
            ? 'No tienes permiso para acceder a estos datos.'
            : 'Hubo un problema al obtener los productos hijos.';
        alert(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    if (productoPadre?.id_producto) {
      fetchProductosHijos();
    }
  }, [productoPadre?.id_producto, token]);

  const idEmpleado = Cookies.get('id_empleado');

  if (loading) {
    return (
      <div className="fixed inset-0 z-50 bg-black-500 bg-opacity-50 flex justify-center items-center">
        <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full text-center">
          <p>Cargando productos hijos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black-500 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full relative">
        {/* Botón de cerrar */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          X
        </button>

        {/* Información general del producto padre */}
        <h2 className="text-2xl font-bold mb-2">
          {productoPadre.nombre_producto} - Productos Variantes
        </h2>
        <div>
          <p>
            <strong>Estado:</strong>{' '}
            <span className={`${getStatusClasses(productoPadre.estado)} px-2 py-1 font-bold rounded`}>
              {productoPadre.estado || 'N/A'}
            </span>
          </p>
          <h3 className="text-lg font-semibold mt-5 mb-5">SKU: {productoPadre.sku}</h3>
          <p className="text-lg">Código de Barras: {productoPadre.codigo_barras}</p>
        </div>
        <div>
          <p className="text-lg">Ubicación: {productoPadre.ubicacion}</p>
        </div>
        <div>
          <p className="text-lg">Stock Mínimo: {productoPadre.stock_minimo}</p>
          {productoPadre.medidas && (
            <p className="text-lg">Medidas: {productoPadre.medidas}</p>
          )}
          {productoPadre.homonimos && (
            <p className="text-lg">Homonimos: {productoPadre.homonimos}</p>
          )}
        </div>
        <div>
          <p className="text-lg">
            Prioridad:{' '}
            <span className={`rounded ${getPriorityClasses(productoPadre.prioridad)}`}>
              {productoPadre.prioridad || 'N/A'}
            </span>
          </p>
          {productoPadre.yhat != null && (
            <p className="text-lg">
              Estimación: {parseFloat(productoPadre.yhat).toFixed(1)}
            </p>
          )}
          <p className="text-lg">Categoría: {productoPadre.nombre_categoria}</p>
        </div>

        {/* Render condicional: Acordeón (mobile) o Tabla (desktop) */}
        {isMobile ? (
          /* Mobile: Acordeón */
          <div className="mt-6">
            {productosHijos.map((prodHijo, index) => (
              <div key={prodHijo.id_producto} className="border rounded mb-4">
                <div
                  className={`p-3 flex justify-between items-center cursor-pointer ${getStatusClasses(prodHijo.estado)}`}
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <div>
                    <p className="font-bold">{prodHijo.nombre_producto}</p>
                    <p className="text-xs">{formatCurrency(prodHijo.precio_venta)}</p>
                    <div className="flex">
                      <ConteoCheck
                        show={prodHijo.tieneMovimientosRecientes}
                        empleado={prodHijo.nombre_empleado}
                        fecha={prodHijo.fecha_ultimo_movimiento}
                      />
                    </div>
                  </div>
                  <span className="text-xl font-bold">
                    {openIndex === index ? '-' : '+'}
                  </span>
                </div>
                {openIndex === index && (
                  <div className="p-4 bg-white">
                    {/* Detalles */}
                    <p className="text-sm text-left">
                      <strong>Cód. Barras:</strong> {prodHijo.codigo_barras} <br />
                      <strong>SKU:</strong> {prodHijo.sku} <br />
                      <strong>Marca:</strong> {prodHijo.marca_hijo} <br />
                      <strong>Precio Compra:</strong>{' '}
                      {prodHijo.precio_compra ? formatCurrency(prodHijo.precio_compra) : 'N/A'} <br />
                      <strong>Cantidad:</strong>{' '}
                      <ComponenteActualizarExistencias
                        producto={prodHijo}
                        idEmpleado={idEmpleado}
                        token={token}
                        onSuccess={({ nuevaCantidad }) => {
                          // Actualiza el estado local con la nueva cantidad
                          setProductosHijos((prev) =>
                            prev.map((p) =>
                              p.id_producto === prodHijo.id_producto
                                ? { ...p, existencias: nuevaCantidad }
                                : p
                            )
                          );
                        }}
                      />
                      <p className='mt-4'>
                        <strong>Estado:</strong>{' '}
                        <span className={`p-1 rounded ${getStatusClasses(prodHijo.estado)}`}>
                          {prodHijo.estado}
                        </span>
                      </p>
                      <p className='mt-4'>
                        <strong>Prioridad:</strong>{' '}
                        <span className={`p-1 rounded ${getPriorityClasses(prodHijo.prioridad)}`}>
                          {prodHijo.prioridad || 'N/A'}
                        </span>
                      </p>
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          /* Desktop: Tabla */
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-yellow-500 text-xs mt-4">
              <thead>
                <tr>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Conteo</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Código de Barras</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">SKU</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Marca</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Precio Venta</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Precio Compra</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Cantidad</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Estado</th>
                  <th className="bg-yellow-500 hover:bg-yellow-400 p-2">Prioridad</th>
                </tr>
              </thead>
              <tbody>
                {productosHijos.map((producto) => (
                  <tr
                    key={producto.id_producto}
                    className="hover:bg-yellow-200 text-center text-xs"
                  >
                    <td className="border-b border-yellow-500 p-1 text-center">
                      <div className="flex justify-center items-center">
                        <ConteoCheck
                          show={producto.tieneMovimientosRecientes}
                          empleado={producto.nombre_empleado}
                          fecha={producto.fecha_ultimo_movimiento}
                        />
                      </div>
                    </td>
                    <td className="border-b border-yellow-500 p-1 text-left">
                      <button
                        onClick={() => copyToClipboard(producto.codigo_barras)}
                        className="text-blue-500 hover:text-blue-700 mr-2"
                      >
                        <FaCopy className="w-4 h-4" />
                      </button>
                      <a
                        href={`/productos/vista/${producto.id_producto}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        {producto.codigo_barras}
                      </a>
                    </td>
                    <td className="border-b border-yellow-500 p-1">{producto.sku}</td>
                    <td className="border-b border-yellow-500 p-1">{producto.marca_hijo}</td>
                    <td className="border-b border-yellow-500 p-1">
                      {producto.precio_venta
                        ? formatCurrency(producto.precio_venta)
                        : 'N/A'}
                    </td>
                    <td className="border-b border-yellow-500 p-1">
                      {producto.precio_compra
                        ? formatCurrency(producto.precio_compra)
                        : 'N/A'}
                    </td>
                    <td className="border-b border-yellow-500 p-1">
                      <ComponenteActualizarExistencias
                        producto={producto}
                        idEmpleado={idEmpleado}
                        token={token}
                        onSuccess={({ nuevaCantidad }) => {
                          setProductosHijos((prev) =>
                            prev.map((p) =>
                              p.id_producto === producto.id_producto
                                ? { ...p, existencias: nuevaCantidad }
                                : p
                            )
                          );
                        }}
                      />
                    </td>
                    <td
                      className={`border-b border-yellow-500 p-1 ${getStatusClasses(
                        producto.estado
                      )}`}
                    >
                      {producto.estado}
                    </td>
                    <td
                      className={`border-b border-yellow-500 p-1 font-bold ${getPriorityClasses(
                        producto.prioridad
                      )}`}
                      data-tooltip-id={`tooltip-yhat-${producto.id_producto}`}
                      data-tooltip-content={
                        producto.yhat !== null
                          ? `Estimación: ${parseFloat(producto.yhat).toFixed(2)}`
                          : 'N/A'
                      }
                    >
                      {producto.prioridad || 'N/A'}
                      <Tooltip
                        id={`tooltip-yhat-${producto.id_producto}`}
                        place="top"
                        style={{
                          fontSize: '14px',
                          zIndex: 9999,
                          whiteSpace: 'nowrap',
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalProductoPadre;
